import '../../common/bn-icon';
import '../../organizations/parts/organization-ancestors-bread-crumbs';
import { LitEntity, html, css } from '../../utility/lit-entity';
import { sharedStyles } from '../../styles/shared-styles';

class WorkOrderHeader extends LitEntity {
  static get styles() {
    return [sharedStyles, css`
      :host {
        display: flex;
      }
      .headings {
        flex-grow: 1;
        overflow: auto;
      }
      bn-icon {
        color: var(--blue-60);
        font-size: 40px;
        margin-right: 1rem;
      }
      h3 {
        margin-top: 0;
      }
    `];
  }

  render() {
    if (this.loading) {
      return html``;
    }

    const binHref = this.getHref('https://api.binsentry.com/rel/bin');

    return html`
      <bn-icon name="fad fa-tools"></bn-icon>
      <div class="headings">
        <h3>
          <bin-path-name .href="${binHref}" stop-at-type="farm"></bin-path-name>
        </h3>
        <h4>
          #${this.getProperty('referenceId')}
        </h4>
      </div>
    `;
  }
}

customElements.define('work-order-header', WorkOrderHeader);
